<template>
  <!--<b-modal id="modal-1" scrollable centered size="lg" v-model="show" hide-footer>
    <template v-slot:modal-header>
        <b-row class="w-100" align-v="center">
            <b-col>
                <h5> Histórico da Proposta </h5>
            </b-col>
            <b-col class="text-right">
                <h5>
                    <i class="fa fa-times pointer" @click="$emit('hideModal')"></i>
                </h5>
            </b-col>
        </b-row>
    </template>-->
    <div class="d-block text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12 p-0" v-if="!loading">
                    <!--<ul class="timeline" v-if="timelineArray.length">
                        <li class="text-left" v-for="(timeline, index) in timelineArray" :key="index">
                            <a target="_blank" href="https://www.totoprayogo.com/#">{{timeline.user}}</a>
                            <a href="#" class="float-right">{{timeline.date | getdate}}</a>
                            <div v-for="(proposal, index2) in timeline.updatedProposalValue" :key="index2" class="mb-1">
                               <div v-if="index2 !== 'steps'">
                                <strong>{{index2}}:</strong> {{proposal}} 
                               </div>
                               <div v-else>
                                   <strong>Steps</strong>
                                   <div v-for="(step, index3) in timeline.updatedProposalValue[index2]" :key="index3">
                                       <div class="text-primary"><strong>{{index3}}</strong></div>
                                       <span v-for="(val, index4) in timeline.updatedProposalValue[index2][index3]" :key="index4">
                                           <strong>{{index4}}:</strong> {{val}}
                                       </span>
                                   </div>
                               </div>
                            </div>
                        </li>
                    </ul>-->
                    <ul class="timeline" v-if="timelineArray.length">
                        <li class="text-left mb-5" v-for="(timeline, index) in timelineArray" :key="index">
                            <span class="text-primary" href="#">{{timeline.date | getdate}} - {{timeline.time}}</span>
                            <span class="text-primary float-right"><i>{{timeline.user}}</i></span>
                            <hr>
                            <div v-for="(proposal, index2) in timeline.updatedProposalValue" :key="index2" class="mb-1">
                                <b-row v-if="index2 !== 'steps'">
                                    <b-col><strong  class="light">{{index2}}</strong></b-col>
                                    <b-col>Old Value / <i>{{proposal}}</i></b-col>
                                </b-row>
                                <b-row v-else v-for="(step, index3) in timeline.updatedProposalValue[index2]" :key="index3">
                                    <hr>
                                    <b-col><strong>{{index3}}</strong></b-col>
                                    <b-col>Old Value / <i>{{ timeline.updatedProposalValue[index2][index3].situation == '' ? '-' : timeline.updatedProposalValue[index2][index3].situation}}</i></b-col>
                                    <b-col>Old Value / <i>{{ timeline.updatedProposalValue[index2][index3].status == '' ? '-' : timeline.updatedProposalValue[index2][index3].status }}</i></b-col>
                                </b-row>
                                <!--<div v-if="index2 !== 'steps'">
                                    <table class="table table-sm mt-2 mb-0">
                                        <tbody>
                                            <tr>
                                                <th>{{index2}}</th>
                                                <td><i>Old Value</i> / {{proposal}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else>
                                   <div v-for="(step, index3) in timeline.updatedProposalValue[index2]" :key="index3">
                                       <table class="table mt-2 mb-0">
                                        <tbody>
                                            <tr>
                                                <th>{{ index3 }}</th>
                                                <th>{{ index3 === 'riskAssessment' ? 'Avaliação de Risco' || index3 === 'engineering' : 'Engenharia' }}</th>-->
                                                <!--<td><i>Old Value</i> / {{ timeline.updatedProposalValue[index2][index3].situation == '' ? '-' : timeline.updatedProposalValue[index2][index3].situation}}</td>
                                                <td><i>Old Value</i> / {{ timeline.updatedProposalValue[index2][index3].status == '' ? '-' : timeline.updatedProposalValue[index2][index3].status }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                   </div>
                               </div>-->
                            </div>
                        </li>
                    </ul>

                    <div v-else class="timeline">
                        <i class="fa fa-exclamation-triangle text-warning"></i>
                        <p>Oops! Nenhum histórico encontrado.</p>
                    </div>
                </div>
                <div v-else class="col-md-12">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Spinning"></b-spinner>
                </div>
            </div>
        </div>
    </div>
  <!--</b-modal>-->
</template>

<script>
export default {
    name: 'TimeLineModal',
    props: ['show', 'loading', 'timelineArray'],
    filters: {
        getdate (value) {
            let date = new Date(value)
            return date.getDate() + '/' + date.toLocaleString('default', { month: '2-digit' }) + '/' + date.getFullYear()
        }
    }
}
</script>

<style>

.themeColor {
    color: #007bff;
}

.pointer {
    cursor: pointer;
}

ul.timeline {
    list-style-type: none;
    position: relative;
}
ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}
ul.timeline > li {
    margin: 20px 0;
    padding-left: 20px;
}
ul.timeline > li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #22c0e8;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}
</style>